define(['app/modules/test'], function(Test) {

  var Tests = function () {};

  Tests.prototype.actionRun = function () {
    var testPage = $('.ca-test-page-run');
    var question = testPage.find('.ca-test-question');
    var testId = testPage.data('id');
    var testProgress = $('.ca-question-progress');
    var testTimer = Test.setClock(testPage, testId);
    var timeout;

    window.onbeforeunload = function() {
      timeout = setTimeout(function(){ Test.getQuestion(testId, testTimer, testProgress); }, 1000);
      return "Do you want to close this page without save?";
    };
    window.onunload = function(){
      clearTimeout(timeout);
      Test.finish(testId);
    };

    Test.getQuestion(testId, testTimer, testProgress);

    question.on('submit', '.ca-test-answer-form', function(e){
      e.preventDefault();
      e.stopPropagation();
      Test.createAnswer($(this), testTimer, testProgress);
    });
  };

  Tests.prototype.actionShow = function () {
    $('.ca-test-answer-btn').on('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      Test.exampleAnswer($(this).closest('.ca-example-question'));
    });

    $('.ca-example-collapse').on('show.bs.collapse', function (e) {
      if($(this).closest('.ca-example-question').hasClass('disabled')){
        e.preventDefault();
        e.stopPropagation();
      }
    })
  };

  return Tests;
});
